<template>
  <div class="margin-top-half">
    <div class="card card-outline">
      <div class="card-header card-header-blue">
        Autorizados Aseos
        <div
          v-if="selectedProductionLine != null"
          class="card-header-blue__after"
        >
          {{ lstOutputWorkers.length }}
          /  {{ selectedProductionLine.TrabajadoresFueraLineaAutorizados }}
        </div>
      </div>
      <div class="padding-horizontal-half padding-top-half bg-lightgray">
        <div class="card-content-text">
          <div class="padding-left-half padding-bottom-half">
            Trabajadores En Aseos
          </div>
        </div>
        <div class="content-list-queue">
          <div class="content-list">
            <UCPreload
              :number="1"
              :show="showPreloadOutputWorkers"
            />
            <div
              v-for="petition in lstOutputWorkers"
              :key="petition.Id"
              no-gap
            >
              <div>
                <div class="content-list-queue-item margin-bottom-half">
                  <div class="content-list-queue-item__img">
                    <span
                      v-if="petition.NumeroAseo !== ''"
                      class="div-number-ase"
                    > {{ petition.NumeroAseo }}</span>
                    <img
                      v-if="petition.Trabajador.Sujeto.ImagenPerfil == null"
                      src="@/static/icons/ic_user.svg"
                    >
                    <img
                      v-if="petition.Trabajador.Sujeto.ImagenPerfil != null"
                      :src="petition.Trabajador.Sujeto.ImagenPerfil.Archivo"
                    >
                  </div>

                  <div class="content-list-queue-item__title">
                    {{ TextMaximumLength(petition.Trabajador.Sujeto.NombreCompleto, 40) }}
                  </div>
                  <div
                    class=""
                    @click="FinalizeOutputWorker(petition.Trabajador)"
                  >
                    <img
                      class="content-list-queue-item__icon"
                      width="20"
                      src="@/static/icons/ic_cancel_round.svg"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="padding-half bg-lightsnow">
        <div class="card-content-text">
          <div class="padding-left-half padding-bottom-half">
            Trabajadores en cola
          </div>
        </div>
        <div class="content-list-queue">
          <div class="content-list">
            <UCPreload
              :number="1"
              :show="showPreloadQueueOfWorkerPetitions"
            />
            <div
              v-for="petition in queueOfWorkerPetitions"
              :key="petition.Id"
              no-gap
            >
              <div>
                <div class="content-list-queue-item margin-bottom-half">
                  <div class="content-list-queue-item__img">
                    <span
                      v-if="petition.NumeroAseo !== ''"
                      class="div-number-ase"
                    > {{ petition.NumeroAseo }}</span>
                    <img
                      v-if="petition.Trabajador.Sujeto.ImagenPerfil == null"
                      src="@/static/icons/ic_user.svg"
                    >
                    <img
                      v-if="petition.Trabajador.Sujeto.ImagenPerfil != null"
                      :src="petition.Trabajador.Sujeto.ImagenPerfil.Archivo"
                    >
                  </div>

                  <div class="content-list-queue-item__title temp-nombre">
                    {{ TextMaximumLength(petition.Trabajador.Sujeto.NombreCompleto, 40) }}
                  </div>
                  <div
                    class=""
                    @click="AuthorizeOutputWorker(petition.Trabajador)"
                  >
                    <img
                      class="content-list-queue-item__icon"
                      width="20"
                      src="@/static/icons/ic_up.svg"
                    >
                  </div>
                  <!--
                  <div
                    v-if="petition.NumeroAseo !== ''"
                    class="div-number-ase"
                  >
                    <span> {{ petition.NumeroAseo }}</span>
                  </div>
                  -->
                  <!-- Indicar el Nº De Aseo -->
                  <div
                    class="btn-add-info-output-worker"
                    @click="AddInfoOutputWorker(petition)"
                  >
                    <img
                      class="content-list-queue-item__icon"
                      width="20"
                      alt="iconInfo"
                      src="@/static/icons/ic_info.svg"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { f7 } from 'framework7-vue';
import {
  Log,
  LogError,
} from '@/js/common/HIDebuggingSupport';
import APIErp, { callGetPhotosProfileSubjects } from '@/js/services/APIErp';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import { HiDateTimeSupport, HiStringSupport } from '@/js/common/HIConversionSupport';

export default {
  name: 'PCProductionLineOutputAuthorizations',
  components: {
    UCPreload,
  },
  props: {
    selectedProductionLine: { type: Object, default: null },
  },

  emits: ['authorized-worker-output'],

  data() {
    return {
      queueOfWorkerPetitions: [], // Mantiene la cola de trabajadores pendientes de ser autorizados.
      lstOutputWorkers: [], // Mantiene la lista de los trabajadores autorizados
      showPreloadOutputWorkers: false,
      showPreloadQueueOfWorkerPetitions: false,
    };
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    AddWorkers(lstWorkers) {
      Log(this, this.AddWorkers.name);

      if (lstWorkers == null || lstWorkers.length === 0) {
        HiNotification.Toast('Es necesario seleccionar al menos a un trabajador', 4000);
        return;
      }
      this.showPreloadQueueOfWorkerPetitions = true;
      this.queueOfWorkerPetitions = [];
      const self = this;
      const currentDate = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss');
      this.Conections_RequestLineOutAuthorization(this.selectedProductionLine, lstWorkers, currentDate)
        .catch((error) => {
          HiNotification.Toast(`No es posible hacer la petición. ${error}`, 14000);
        })
        .finally(() => {
          self.showPreloadQueueOfWorkerPetitions = false;
          self.GetRequestWorkerOutputLine();
        });
    },

    /**
     * @public
     * @returns {void}
     */
    Refresh() {
      this.GetWorkerOutputLine();
      this.GetRequestWorkerOutputLine();
    },

    TextMaximumLength(cadena, longitudMaxima) {
      return HiStringSupport.TextMaximumLength(cadena, longitudMaxima);
    },
    Clear() {
      Log(this, this.Clear.name);
      this.queueOfWorkerPetitions = [];
      this.lstOutputWorkers = [];
    },
    GetWorkerOutputLine() {
      Log(this, this.GetWorkerOutputLine.name);

      if (this.selectedProductionLine === null) {
        LogError(this, this.$t('common.needToSelectAProductionLine'));
        return;
      }
      this.showPreloadOutputWorkers = true;
      this.lstOutputWorkers = [];
      const self = this;
      this.Conections_GetWorkersOutputLine(this.selectedProductionLine).then((result) => {
        // Pueden existir más de una petición para cada zona (diferentes aseos)
        // para cada trabajador, dejamos solo la primera
        if (Array.isArray(result)) {
          result.forEach((e) => {
            if (self.lstOutputWorkers
              .find((el) => el.Trabajador.Id === e.Trabajador.Id) === undefined) {
              self.lstOutputWorkers.push(e);
            }
          });
        }

        // self.lstOutputWorkers = result;
      }).catch(() => {
        HiNotification.Toast('No es posible obtener los trabajadores autorizados que actualmente estan fuera de la linea de producción.', 14000);
      }).finally(() => {
        self.showPreloadOutputWorkers = false;
        // Obtenemos las fotografias.
        const arrSubjects = self.lstOutputWorkers.map((w) => w.Trabajador.Sujeto);
        this.Conections_GetPhotosProfileSubjects(arrSubjects).then((data) => {
          if (data.length > 0) {
            self.lstOutputWorkers.forEach(
              (e) => {
                const objImg = data.find((s) => s.Id === e.Trabajador.Sujeto.Id);
                e.Trabajador.Sujeto.ImagenPerfil = objImg.ImagenPerfil;
              },
            );
          }
        });
      });
    },
    GetRequestWorkerOutputLine() {
      Log(this, this.GetRequestWorkerOutputLine.name);
      if (this.selectedProductionLine === null) {
        LogError(this, this.$t('common.needToSelectAProductionLine'));
        return;
      }
      this.showPreloadQueueOfWorkerPetitions = true;
      this.queueOfWorkerPetitions = [];
      const self = this;
      this.Conections_GetRequestWorkersOutputLine(this.selectedProductionLine).then((result) => {
        // Pueden existir más de una petición para cada zona (diferentes aseos)
        // para cada trabajador, dejamos solo la primera
        if (Array.isArray(result)) {
          result.forEach((e) => {
            if (self.queueOfWorkerPetitions
              .find((el) => el.Trabajador.Id === e.Trabajador.Id) === undefined) {
              self.queueOfWorkerPetitions.push(e);
            }
          });
        }
      }).catch(() => {
        HiNotification.Toast('No es posible obtener los trabajadores autorizados que actualmente estan fuera de la linea de producción.', 14000);
      }).finally(() => {
        self.showPreloadQueueOfWorkerPetitions = false;
        // Obtenemos las fotografias.
        const arrSubjects = self.queueOfWorkerPetitions.map((w) => w.Trabajador.Sujeto);
        this.Conections_GetPhotosProfileSubjects(arrSubjects).then((data) => {
          if (data.length > 0) {
            self.queueOfWorkerPetitions.forEach(
              (e) => {
                const objImg = data.find((s) => s.Id === e.Trabajador.Sujeto.Id);
                e.Trabajador.Sujeto.ImagenPerfil = objImg.ImagenPerfil;
              },
            );
          }
        });
      });
    },
    AuthorizeOutputWorker(pWorker) {
      Log(this, this.AuthorizeOutputWorker.name);
      if (pWorker == null) {
        HiNotification.Toast('Es necesario seleccionar un trabajador al que autorizar la salida.', 14000);
        return;
      }
      HiDialog.Preloader(true, 'Autorizando trabajador...', true, '');
      const self = this;
      const currentDate = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss');
      this.Conections_AuthorizeOutputWorker(
        this.selectedProductionLine,
        pWorker,
        currentDate,
      ).then(() => {
        self.$emit('authorized-worker-output');
      }).catch((msgError) => {
        HiNotification.Toast(`No es posible autorizar la salida del trabajador. ${msgError}`, 14000);
        self.Refresh();
      }).finally(() => {
        HiDialog.Preloader(false);
      });
    },
    FinalizeOutputWorker(pWorker) {
      Log(this, this.FinalizeOutputWorker.name);
      if (pWorker == null) {
        HiNotification.Toast('Es necesario seleccionar un trabajador al que finalizar la autorización de salida', 14000);
        return;
      }
      HiDialog.Preloader(true, 'Finalizando autorización trabajador...', true, '');
      const self = this;
      const currentDate = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss');
      this.Conections_FinalizeOutputWorker(
        this.selectedProductionLine,
        pWorker,
        currentDate,
      ).then(() => {
        self.$emit('authorized-worker-output');
      }).catch((msgError) => {
        HiNotification.Toast(`No es posible revocar la autorización del trabajador. ${msgError}`, 14000);
        self.GetWorkerOutputLine();
      }).finally(() => {
        HiDialog.Preloader(false);
      });
    },
    async AddInfoOutputWorker(objPetition) {
      Log(this, this.AddInfoOutputWorker.name);
      f7.dialog.prompt('Indica el número de aseo asignado', 'Número de aseo', (value) => {
        objPetition.NumeroAseo = value;
        this.Conections_SavePetition(objPetition);
      });
    },
    /* ****************** CONNECTIONS  ********************* * */
    /* ******************************************************** */
    Conections_SavePetition(objPetition) {
      return new Promise((resolve, reject) => {
        APIErp.callSavePetitionAreaAuthorization([objPetition])
          .then((result) => {
            resolve(result.data);
          }).catch((error) => {
            LogError(this, this.Conections_SavePetition.name, error);
            reject();
          });
      });
    },
    Conections_GetWorkersOutputLine(objLine) {
      Log(this, this.Conections_GetWorkersOutputLine.name);
      return new Promise((resolve, reject) => {
        APIErp.callGetWorkersOutputLine(objLine.Id)
          .then((result) => {
            if (result.data.valor) {
              resolve(result.data.tag);
            } else {
              reject();
            }
          }).catch((error) => {
            LogError(this, this.Conections_GetWorkersOutputLine.name, error);
            reject(error);
          });
      });
    },
    Conections_GetRequestWorkersOutputLine(objLine) {
      Log(this, this.Conections_GetRequestWorkersOutputLine.name);
      return new Promise((resolve, reject) => {
        APIErp.callGetRequestWorkersOutputLine(objLine.Id)
          .then((result) => {
            if (result.data.valor) {
              resolve(result.data.tag);
            } else {
              reject();
            }
          }).catch((error) => {
            LogError(this, this.Conections_GetRequestWorkersOutputLine.name, error);
            reject(error);
          });
      });
    },
    Conections_AuthorizeOutputWorker(objLine, objWorker, dateTime) {
      Log(this, this.Conections_AuthorizeOutputWorker.name);
      return new Promise((resolve, reject) => {
        APIErp.callAuthorizeOutputWorker(objLine.Id, objWorker.Id, dateTime)
          .then((result) => {
            if (result.data.valor) {
              resolve();
            } else {
              reject(result.data.mensaje);
            }
          }).catch((error) => {
            LogError(this, this.Conections_AuthorizeOutputWorker.name, error);
            reject();
          });
      });
    },
    Conections_FinalizeOutputWorker(objLine, objWorker, dateTime) {
      Log(this, this.Conections_FinalizeOutputWorker.name);
      return new Promise((resolve, reject) => {
        APIErp.callFinalizeOutputWorker(objLine.Id, objWorker.Id, dateTime)
          .then((result) => {
            if (result.data.valor) {
              resolve();
            } else {
              reject(result.data.mensaje);
            }
          }).catch((error) => {
            LogError(this, this.Conections_FinalizeOutputWorker.name, error);
            reject(error);
          });
      });
    },
    Conections_RequestLineOutAuthorization(objLine, lstWorker, dateTime) {
      Log(this, this.Conections_RequestLineOutAuthorization.name);
      return new Promise((resolve, reject) => {
        APIErp.callRequestLineOutAuthorization(objLine, lstWorker, dateTime)
          .then((result) => {
            if (result.data.valor) {
              resolve();
            } else {
              reject(result.data.mensaje);
            }
          }).catch((error) => {
            LogError(this, this.Conections_RequestLineOutAuthorization.name, error);
            reject(error);
          });
      });
    },
    Conections_GetPhotosProfileSubjects(arrObjSubjects) {
      return new Promise((resolve, reject) => {
        callGetPhotosProfileSubjects(arrObjSubjects)
          .then((result) => {
            resolve(result.data);
          }).catch((error) => {
            LogError(this, this.Conections_GetPhotosProfileSubjects.name, error);
            reject();
          });
      });
    },
  },
};
</script>

<style lang="scss">
.card-outline {
  margin-left: 0;
  margin-right: 0;
}

.card-header-blue {
  background-color: var(--his-steel-blue) !important;
  font-size: 13px;
  font-weight: 500;
  color: #fff;

  &__after {
    padding: 3px 8px;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    background: var(--his-plum-shadow);
    border-radius: 3px;
  }
}

.card-content-text {
  color: #253858;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 12px;
}

.content-list-queue {
  margin-top: 0;

  .content-list-queue-item {
    padding: 8px 10px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d4e2f0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__img {
      display: flex;
      align-items: center;

      img {
        width: 34px;
        height: 34px;
        border-radius: 25%;
      }

      .div-number-ase {
        position: absolute;
        padding: 2px 3px;
        background-color: rgb(242 110 72 / 70%);
        border-radius: 22px;
        font-size: 9px;
        color: #fff;
        left: 4px;
      }
    }

    &__title {
      color: var(--his-steel-blue);
      font-size: 12px;
      padding-left: 10px;
      line-height: var(--f7-list-item-title-line-height);
      font-weight: 500;
      align-items: center;
      justify-content: space-between;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    }

    &__icon {
      width: 22px;
      height: 22px;
    }
  }
}
</style>
